import { s, typographyTokens } from '@/theme/tokens';
import { Box } from '@/ui/primitives';
import { InfoOutlinedIcon } from '@/ui/primitives/icons';
import type { ReactElement } from 'react';

type ChartPanelTitleProps = {
  title: string;
  component?: 'div' | 'h2' | 'span';
  fontSizePx?: number;
  fontWeight?: number;
  justifyContent?: 'flex-start' | 'center';
  showInfoIcon?: boolean;
};

export const ChartPanelTitle = ({
  title,
  component = 'div',
  fontSizePx = 18,
  fontWeight = typographyTokens.body.fontWeight,
  justifyContent = 'flex-start',
  showInfoIcon = true,
}: ChartPanelTitleProps): ReactElement => (
  <Box
    component={component}
    sx={{
      m: s('none'),
      minWidth: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent,
      gap: s('sm'),
      color: (theme) => theme.app.colors.textMuted,
      fontSize: (muiTheme) => muiTheme.typography.pxToRem(fontSizePx),
      fontWeight,
      lineHeight: 1.25,
      whiteSpace: 'nowrap',
    }}
  >
    <Box component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {title}
    </Box>
    {showInfoIcon ? (
      <InfoOutlinedIcon
        aria-hidden="true"
        sx={{ flexShrink: 0, fontSize: 17, color: 'inherit', transform: 'translateY(1px)' }}
      />
    ) : null}
  </Box>
);
